import React from "react";

export default function CustomTable({ data, editLocation, deleteLocation }) {
  return (
    <div style={{ overflowX: "scroll" }} className="my-4">
      <div className="custom-table-head-2">
        <div>
          <p className="cw-180">Name</p>
        </div>
        <div>
          <p className="cw-180">Description</p>
        </div>
        <div>
          <p className="cw-180">Rooms</p>
        </div>
        <div>
          <p className="cw-160">Action</p>
        </div>
      </div>
      {data?.map(({ name, descriptiuon, rooms, _id }) => (
        <div className="custom-table-cells-2">
          <div>
            <p className="cw-180">{name}</p>
          </div>
          <div>
            <p className="cw-180">{descriptiuon}</p>
          </div>
          <div>
            {rooms.map((f) => (
              <div className="cw-180">{f}</div>
            ))}
          </div>

          <div className="d-flex cw-160">
            <div
              className="mx-3  cursor-pointer icon-width"
              onClick={() => {
                editLocation(name);
              }}
            >
              <i className="fa fa-pen"></i>
            </div>
            <div
              className="mx-3  cursor-pointer icon-width"
              onClick={() => {
                deleteLocation(name);
              }}
            >
              <i className="fa fa-trash"></i>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
